import React from "react";
import GirlFrame from "../../../Images/girlFrame.svg";
import "./Blog.css";

export const Blogimage = () => {
  return (
    <div className="Blogimages">
      <div className="background-blog">
        <img src={GirlFrame} alt="" />
      </div>
    </div>
  );
};
